import {css, StyleSheet} from "aphrodite";
import React, {useEffect, useState} from 'react';
import GridStyles from "../../styles/styles";
import Config from "../../config/Config";
import Image from "../containers/Image";
import TextDiv from "../containers/TextDiv";
import FeedbackButton from "../FeedbackButton";
import WhatsNewAreaUtils from "../WhatsNewArea/WhatsNewAreaUtils";
import MediaQuery from "../../styles/MediaQuery";
import {useSelector} from "react-redux";
import StepsArea from "../StepsArea";

const SwitchD = ({extraStyle}) => {
    const {isMobile} = useSelector(state => state.styles),
        [wallpaperHeight, setWallpaperHeight] = useState(getWallpaperHeight()),
        styles = StyleSheet.create({
            container: {
                ...GridStyles.define("minmax(20px, auto) max-content auto", "minmax(20px, auto) auto minmax(20px, auto)"),
                minHeight: wallpaperHeight,
                backgroundImage: `url(${Config.images.BROWSER_BACKGROUND})`,
                backgroundSize: "cover",
                backgroundPosition: "center center",
                backgroundRepeat: "no-repeat",
                color: Config.colors.WHATS_NEW_TEXT,
                ...MediaQuery.mobile({
                    ...GridStyles.define("minmax(30px, auto) max-content minmax(50px, auto)", "minmax(20px, auto) auto minmax(20px, auto)"),
                })
            },
            wrapper: {
                ...GridStyles.setRowCol(2, 2),
                ...GridStyles.define("max-content 20px max-content 10px max-content 12px max-content", "auto"),
                justifyContent: "center"
            },
            textWrapper: {
                ...GridStyles.setRowCol(1, 1),
                ...GridStyles.define("max-content", "minmax(200px, 480px) 37px minmax(200px, 540px)"),
                ...MediaQuery.mobile({
                    ...GridStyles.define("max-content 35px max-content", "auto"),
                })
            },
            textArea: {
                ...GridStyles.setRowCol(1, 1),
                ...GridStyles.define("max-content 12px max-content", "auto"),
                ...MediaQuery.mobile({
                    ...GridStyles.setRowCol(3, 1),
                    ...GridStyles.define("max-content 17px max-content", "auto"),
                    textAlign: "center"
                })
            },
            title: {
                ...GridStyles.setRowCol(1, 1),
                fontSize: 56,
                lineHeight: 1.07,
                fontWeight: "bold",
                ...MediaQuery.mobile({
                    fontSize: 46,
                    lineHeight: 1.09
                })
            },
            subtitle: {
                ...GridStyles.setRowCol(3, 1),
                fontSize: 16,
                lineHeight: 1.63,
                ...MediaQuery.mobile({
                    fontSize: 17,
                    lineHeight: 1.65
                })
            },
            image: {
                ...GridStyles.setRowCol(1, 3),
                maxWidth: 532,
                maxHeight: 323,
                width: "100%",
                height: "auto",
                ...MediaQuery.mobile({
                    ...GridStyles.setRowCol(1, 1),
                    maxWidth: 311,
                    maxHeight: 189,
                    margin: "0 auto"
                })
            },
            stepsArea: GridStyles.setRowCol(3, 1),
            button: {
                ...GridStyles.setRowCol(5, 1),
                margin: "0 auto"
            },
            download: {
                ...GridStyles.setRowCol(7, 1),
                fontSize: 13,
                lineHeight: 1.85,
                textAlign: "center",
                fontWeight: "bold",
                "> a": {
                    color: "white"
                },
                ...MediaQuery.mobile({
                    fontSize: 15,
                    lineHeight: 1.6
                })
            }
        }),
        downloadText = isMobile ? WhatsNewAreaUtils.getDownloadTextMobile() : WhatsNewAreaUtils.getDownloadText();

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [wallpaperHeight]);

    useEffect(() => {
        setWallpaperHeight(getWallpaperHeight());
    }, []);

    function handleResize() {
        setWallpaperHeight(getWallpaperHeight());
    }

    return (
        <div className={css(styles.container, extraStyle)}>
            <div className={css(styles.wrapper)}>
                <div className={css(styles.textWrapper)}>
                    <div className={css(styles.textArea)}>
                        <TextDiv extraStyle={styles.title} text={Config.messages.switchYourBrowser}/>
                        <TextDiv extraStyle={styles.subtitle} text={Config.messages.switchYourBrowserSub}/>
                    </div>
                    <Image extraStyle={styles.image} src={Config.images.SWITCH}/>
                </div>
                <StepsArea extraStyle={styles.stepsArea}/>
                <FeedbackButton extraStyle={styles.button}/>
                <TextDiv extraStyle={styles.download} text={downloadText}/>
            </div>
        </div>
    );
};

export default SwitchD;

function getWallpaperHeight() {
    const header = document.getElementById(Config.styles.HEADER_ID),
        footer = document.getElementById(Config.styles.FOOTER_ID),
        screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

    return header && footer ? screenHeight - footer.clientHeight - header.clientHeight + 1 : "fit-content";
}
